// Messages for doctor dashboard (all patients)
export const ALL_PATIENTS_MESSAGES = [
  "No new alerts, you are all caught up! 🎉",
  "Great work! All your patients are stable 💚",
  "Excellent monitoring! Keep up the vigilant care 👨‍⚕️",
  "All clear! Your patients are in good hands 🙌",
  "Outstanding care! All alerts have been reviewed ⭐",
  "Well done! Your proactive monitoring is paying off 📊",
  "Perfect! You're staying on top of patient care 💯",
  "Superb care! All urgent matters addressed 🏆",
  "Fantastic! Your patients are thriving under your care 🌟",
  "Excellent work! Keep watching over your patients 👀❤️"
]

// Messages for individual patient profile
export const INDIVIDUAL_PATIENT_MESSAGES = [
  "This patient is doing great! No alerts to review 🎉",
  "Excellent! This patient's readings are stable 💚",
  "All good here! This patient's health is on track 👍",
  "No concerns for this patient at the moment ✅",
  "This patient's blood pressure is well managed 📊",
  "Great job! This patient shows healthy readings 🌟",
  "This patient is maintaining good health habits 💪",
  "Stable readings - this patient is doing well! 👨‍⚕️",
  "No alerts needed - this patient's care is effective 🏆",
  "This patient's health monitoring is up to date ⭐"
]

// Generic messages that work for both contexts
export const GENERIC_MESSAGES = [
  "All clear! No urgent matters to address 🙌",
  "Everything looks good! No alerts at this time ✨",
  "No action needed - all readings are stable 📋",
  "Health monitoring is up to date 📈",
  "No alerts to review right now 🔍"
]

export const getRandomMotivationalMessage = (context: 'all-patients' | 'individual-patient' | 'generic' = 'generic'): string => {
  let messages: string[]
  
  switch (context) {
    case 'all-patients':
      messages = ALL_PATIENTS_MESSAGES
      break
    case 'individual-patient':
      messages = INDIVIDUAL_PATIENT_MESSAGES
      break
    case 'generic':
    default:
      messages = GENERIC_MESSAGES
      break
  }
  
  return messages[Math.floor(Math.random() * messages.length)]
} 